import { defineComponent as n, openBlock as s, createBlock as a, withCtx as o, createElementVNode as r, normalizeStyle as c, createTextVNode as i, renderSlot as p } from "vue";
import f from "../FrPopover.js";
import '../assets/AdvertisingLabel.css';const C = /* @__PURE__ */ r("svg", {
  class: "frisbuy-advertising-label__icon",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ r("path", {
    d: "M6.5625 3.56247C6.5625 3.87313 6.31066 4.12497 6 4.12497C5.68934 4.12497 5.4375 3.87313 5.4375 3.56247C5.4375 3.25181 5.68934 2.99997 6 2.99997C6.31066 2.99997 6.5625 3.25181 6.5625 3.56247Z",
    fill: "currentColor"
  }),
  /* @__PURE__ */ r("path", {
    d: "M6 4.95114C5.79289 4.95114 5.625 5.11903 5.625 5.32614V8.62614C5.625 8.83324 5.79289 9.00114 6 9.00114C6.20711 9.00114 6.375 8.83324 6.375 8.62614V5.32614C6.375 5.11903 6.20711 4.95114 6 4.95114Z",
    fill: "currentColor"
  }),
  /* @__PURE__ */ r("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.75 6C0.75 8.8995 3.1005 11.25 6 11.25C7.39239 11.25 8.72774 10.6969 9.71231 9.71231C10.6969 8.72774 11.25 7.39239 11.25 6C11.25 3.10051 8.8995 0.75 6 0.75C3.1005 0.75 0.75 3.10051 0.75 6ZM1.5 6.00055C1.5 8.48583 3.51472 10.5005 6 10.5005C7.19347 10.5005 8.33807 10.0264 9.18198 9.18253C10.0259 8.33862 10.5 7.19402 10.5 6.00055C10.5 3.51527 8.48528 1.50055 6 1.50055C3.51472 1.50055 1.5 3.51527 1.5 6.00055Z",
    fill: "currentColor"
  })
], -1), _ = /* @__PURE__ */ n({
  __name: "AdvertisingLabel",
  props: {
    backgroundColor: {},
    color: {},
    offset: {},
    forceOpen: { type: Boolean },
    arrowSettings: {},
    placement: {}
  },
  setup(t) {
    const e = t;
    return (l, d) => (s(), a(f, {
      trigger: "click",
      placement: e.placement,
      popperClass: "frisbuy-advertising-wrapper",
      offset: e.offset,
      forceOpen: e.forceOpen,
      arrowSettings: e.arrowSettings
    }, {
      reference: o(() => [
        r("div", {
          class: "frisbuy-advertising-label",
          style: c({ color: e.color, backgroundColor: e.backgroundColor })
        }, [
          i(" Реклама "),
          C
        ], 4)
      ]),
      default: o(() => [
        p(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "offset", "forceOpen", "arrowSettings"]));
  }
});
export {
  _
};
